import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          New jobboard.pk coming soon.
        </p>
      </header>
    </div>
  );
}

export default App;
